export const locales = {
  en: require('./en')
};
const messages = {
  uploadTime: '上传时间',
  approvalProcess: '审核进度',
  auditEdition: '审核版',
  onlineEdition: '线上版',
  developEdition: '开发版',
  experienceEdition: '体验版',
  grayEdition: "灰度版",
  grayList: '灰度名单',
  setting: '设置',
  check: "查看",
  grayWraning: "如需结束灰度，请先撤回审核",
  applicationManagement: '应用管理后台',
  developer: '开发者',
  editionNum: '版本号',
  publisher: '发布者',
  publishSubscribe: '版本说明',
  attachment: '附件',
  publishTime: '发布时间',
  effictTime: "生效时间",
  endTime: "到期时间",
  editionPublish: {name: '发布版本', tip: '发布版本后，请联系企业管理员审核，审核通过后企业内成员将使用最新版本。'},
  grayPublish: {name: '提交线上版审核', tip: '提交审核后，请联系企业管理员审核，审核通过后将发布线上版并对企业全员开放使用'},
  isvEditionPublish: {name: '发布版本', tip: '发布版本后，体验版二维码可供使用人员范围内的成员扫码体验'},
  inTouchEnterpriseManager: {name: '联系企业管理员', tip: '版本发布成功后，还需要企业管理员审核，审核通过后员工才能用上新版本'},
  withdrawEdition: {name: '撤回版本', tip: '撤回后会中断管理员的审核'},
  disableTip: '已经被管理员停用，原因如下：',
  applicationManager: '应用责任人',
  coDevelopers: '协同开发者',
  enterpriseManager: '企业管理员',
  allStaff: '全部员工',
  checkInstruction: '设置接口权限',
  editionInstruction: '版本说明',
  NoInstruction: '暂无版本',
  scopeRow: '接口权限',
  ok: '确定',
  cancel: '取消',
  change: '修改',
  chineseName: '中文名',
  version: '版本号',
  submitBy: '提交人',
  previesRes: '预审结果',
  submitTime: '提交时间',
  previewFile: '预审附件',
  preReviewDate: '预审时间',
  auditFileName: '结果附件',
  preview: '预审意见',
  pass: '通过',
  rejected: '驳回',
  preving: '审核中',
  download: '下载',
  contact: '联系方式',
  contactEmail: '申请者邮箱',
  func: '功能稳定性自检',
  funcTable: '功能稳定性审核表',
  safe: '安全自检',
  safeTable: '安全性审核表',
  UCD: 'UCD自检',
  UCDTable: 'UCD审核表',
  upload: '上传',
  downloadExcel: '下载模版',
  submit: '确认提交',
  pcAddress: '应用PC地址',
  goSet: '前往设置',
  applyInfo: '应用信息'
};

export default {locales, ...messages};
